import { setStyle } from 'redom';
import { IStudioOptions } from '../Viewer/interface';

export class UiPointer {
    private container: HTMLElement;

    constructor(container: HTMLElement) {
        this.setContainer(container);

        container.addEventListener('pointerdown', () => {
            if (this.draggable) this.setCursor('grabbing');
        });

        container.addEventListener('pointerup', () => {
            if (this.draggable) this.setCursor('grab');
        });
    }

    public setContainer(container: HTMLElement): void {
        this.container = container;
        this.setDraggable(this.draggable);
    }

    public checkOptions(options: IStudioOptions): void {
        const cam = options.camera;
        const draggable = (
            cam
            && cam.draggableSensibility
            && (cam.draggableSensibility.x !== 0 || cam.draggableSensibility.y !== 0)
        );
        this.setDraggable(draggable);
    }

    private draggable = false;

    public setDraggable(draggable: boolean): void {
        if (draggable) {
            this.setCursor('grab');
        } else {
            this.setCursor('default');
        }
        this.draggable = draggable;
    }

    private setCursor(cursor: string) {
        setStyle(this.container, { cursor });
        // setStyle(this.container, { cursor: cursor + ' !important' });
    }
}
